<!-- header start -->
<header id="sticky">
 
  <!--class="sticky"-->

  <div class="container">
    <div class="row p-3">
      <div class="col-sm-12">
        <div class="main-menu">
          <div class="menu-left">
            <!-- TODO: armar menu de la izquierda que traera los departamentos para armar el filtro
						<div class="navbar">
							<a (click)="openNav()">
								<div class="bar-style">
									<i class="fa fa-bars sidebar-bar" aria-hidden="true"></i>
								</div>
							</a>
							<div id="mySidenav" class="sidenav">
								<a [routerLink]="" class="sidebar-overlay" (click)="closeNav()"></a>
								<nav>
									<div (click)="closeNav()">
										<div class="sidebar-back text-left">
											<i class="fa fa-angle-left pr-2" aria-hidden="true"></i> Back
										</div>
									</div>
									<app-left-menu></app-left-menu>
								</nav>
							</div>
						</div-->
            <div class="brand-logo">
              <a (click)="goHome()">
                <img
                  src="assets/images/logos/logo-distrimay.png"
                  class="img-logo"
                  alt="Distrimay"
                />
              </a>
            </div>
          </div>
          <div>
            <form class="form_search" role="form">
              <input
                id="query search-autocomplete"
                class="nav-search nav-search-field"
                aria-expanded="true"
                name="search"
                placeholder="{{ 'search' | translate }}"
                [(ngModel)]="searchArticle"
                (keyup.enter)="findWeb()"
              />
              <button
                type="button"
                name="nav-submit-button"
                class="btn-search"
                (click)="findWeb()"
              >
                <span class="material-icons">search</span>
              </button>
            </form>
          </div>
          <div class="menu-right pull-right">
            <div>
              <!--<app-navbar></app-navbar>-->
            </div>
            <div>
              <app-header-widgets></app-header-widgets>
            </div>
          </div>
        </div>
      </div>
    </div>   
  </div>
  <img
  src="assets/images/header/header-bg.png"
  class="border-header"
  alt="Distrimay"
/>
</header>
<!-- header end -->
